/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { createBlock } from '@wordpress/blocks';
import { registerPlugin } from '@wordpress/plugins';
import { Component, render } from '@wordpress/element';
import { compose } from '@wordpress/compose';
import { withDispatch } from '@wordpress/data';
import { Icon } from '@wordpress/components';

/**
 * Inner dependencies.
 */
// import Templates from '../templates';

/**
 * Add templates button to Gutenberg toolbar
 */
class ToolbarTemplates extends Component {
	componentDidMount() {
		const { insertBlocks } = this.props;

		const $toolbar = document.querySelector( '.edit-post-header__toolbar' );

		if ( $toolbar ) {
			const LibraryButton = () => (
				<>
					<button
						className="components-button components-icon-button"
						ariaLabel={ __( 'Add Template', '@@text_domain' ) }
						onClick={ ( e ) => {
							e.preventDefault();

							insertBlocks(
								createBlock( 'gutenify/templates-button', {
									isTemplatesModalOnly: true,
								} )
							);
						} }
					>
						<Icon icon="grid-view" />&nbsp;{ __( 'Add Template', '@@text_domain' ) }
					</button>
				</>
			);

			const $toolbarPlace = document.createElement( 'div' );
			$toolbarPlace.classList.add( 'gutenify-toolbar-templates' );

			$toolbar.appendChild( $toolbarPlace );

			render( <LibraryButton />, $toolbarPlace );
		}
	}

	render() {
		return null;
	}
}

registerPlugin( 'gkt-toolbar-templates', {
	render: compose(
		withDispatch( ( dispatch ) => {
			const { insertBlocks } = dispatch( 'core/block-editor' );

			return {
				insertBlocks,
			};
		} )
	)( ToolbarTemplates ),
} );
